import { useState, useMemo, useEffect, useCallback } from "react";
import { DatePickerInput } from "@mantine/dates";
import {
  getEarliestAllowedDateTime,
  generateTimesAMPM,
  parseLocalDateTime,
  formatDateToYMD,
  useSelectScroll,
  globalTableReset,
} from "../helpers/GetAQuoteHelpers";
import { Stack, Select } from "@mantine/core";
import { Clock, Calendar } from "../icons";

export default function DateInput({
  locations,
  location,
  index,
  updateLocation,
  setIsInvalid,
  showDateTimeAsDestintation,
  isRoundTrip,
  useDiy,
}) {
  const [date, setDate] = useState(location.date || null);
  const [time, setTime] = useState(location.time || null);

  const earliestDateTime = getEarliestAllowedDateTime(locations, index);

  const minDate = () => {
    const date = new Date();
    if (useDiy) {
      date.setDate(date.getDate() + 5);
    };

    return earliestDateTime ? formatDateToYMD(earliestDateTime) : formatDateToYMD(date);
  };

  const timeOptions = useMemo(() => {
    return generateTimesAMPM()
      .filter((timeStr) => {
        if (!date || !earliestDateTime) return true;

        const option = parseLocalDateTime(date, timeStr);
        return option >= earliestDateTime;
      })
      .map((t) => ({ value: t, label: t }));
  }, [date, earliestDateTime]);

  const onDropdownOpen = useSelectScroll("8:00 AM");

  useEffect(() => {
    const isInvalid =
      date &&
      time &&
      earliestDateTime &&
      parseLocalDateTime(date, time) < earliestDateTime;
    if (isInvalid) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);
    }
  }, [date, time, earliestDateTime]);

  const datePlaceholder =
    showDateTimeAsDestintation && isRoundTrip ? "Departure date" : "Date";
  const timePlaceholder =
    showDateTimeAsDestintation && isRoundTrip ? "Departure time" : "Time";

  return (
    <Stack>
      <style>{globalTableReset}</style>
      <DatePickerInput
        weekendDays={[]}
        placeholder={datePlaceholder}
        value={date}
        minDate={minDate()}
        firstDayOfWeek={0}
        leftSection={
          <Calendar style={{ color: "#646464" }} width={10} height={10} />
        }
        onChange={(value) => {
          setDate(value);
          updateLocation(index, { date: value });
        }}
        styles={{
          table: {
            borderCollapse: "collapse !important",
            border: "0px none transparent !important",
            borderSpacing: "0 !important",
          },
          tbody: { border: "0 none transparent !important" },
          tr: { border: "0 none transparent !important" },
          td: {
            border: "0px none transparent !important",
            padding: "0 !important",
            outline: "none !important",
            boxShadow: "none !important",
          },
          th: {
            border: "0px none transparent !important",
            padding: "0 !important",
          },
          day: {
            border: "0px none transparent !important",
            outline: "none !important",
            boxShadow: "none !important",
          },
        }}
        popoverProps={{
          withinPortal: true,
          portalProps: { target: "#get-a-quote" },
          zIndex: 10000,
          position: "bottom-start",
          offset: 5,
          styles: {
            dropdown: {
              width: "300px",
              backgroundColor: "#ffffff",
              border: "1px solid #dee2e6",
              visibility: "visible",
              opacity: 1,
            },
          },
        }}
      />
      <Select
        data={timeOptions}
        onDropdownOpen={onDropdownOpen}
        value={time}
        placeholder={timePlaceholder}
        leftSection={
          <Clock style={{ color: "#646464" }} width={10} height={10} />
        }
        onChange={(value) => {
          setTime(value);
          updateLocation(index, { time: value });
        }}
        comboboxProps={{
          withinPortal: true,
          portalProps: { target: "#get-a-quote" },
        }}
      />
    </Stack>
  );
}
